export default "__VITE_ASSET__5b7cc367__"